import React from 'react';
import styles from "./styles.module.scss";
import MultiSelectCellComponentWithSearch from '../../../../views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch';
import PencilIcon from "assets/img/svg/svgComponents/PencilIcon";
import { getFormatedDate } from '../../../../views/pages/manage/unAssigned/concessionApproval/common';


const extractConfigInfo = config => {
    const {businessArea, updatedOn, approvalSettingDTO, updatedBy} = config;
    let transferTypes = [];
    let l1Roles = new Set();
    let l2Roles = new Set();
    approvalSettingDTO.forEach(el => {
        transferTypes = [...transferTypes, el?.transferType];
        el.l1Roles.forEach(role => l1Roles.add(role));
        el.l2Roles.forEach(role => l2Roles.add(role));
    })

    return { transferTypes, l1Roles, l2Roles, businessArea, updatedOn, updatedBy }
}


const ConfigSummaryCard = ({
    config,
    editConfigHandler,
    isUpdatePermission
}) => {
    console.log('config', config);

    const { transferTypes, businessArea, l1Roles, l2Roles, updatedOn , updatedBy} = extractConfigInfo(config);
    return (
        <div className={'d-flex flex-column justify-content-between ' + styles['config-summary-card']}>
            <div className={`d-flex justify-content-between`}>
                <MultiSelectCellComponentWithSearch data={transferTypes} title={'Transfer Types'} />
                {isUpdatePermission && <span onClick={() => editConfigHandler(config)} className={`${styles['edit-icon']}`}><PencilIcon /></span>}
            </div>
            <hr className='w-100' />
            <div>
                <div className={styles['label']}>ACTIVE IN {businessArea?.length} BRANCHES</div>
                <MultiSelectCellComponentWithSearch data={businessArea} title={"Business Areas"} />
            </div>

            <div className='d-flex justify-content-between'>
                <div>
                    <div className={styles['label']}>L1 ROLES</div>
                    <MultiSelectCellComponentWithSearch data={[...l1Roles]} title={"L1 Roles"} />
                </div>
                <div>
                    <div className={styles['label']}>L2 ROLES</div>
                    <MultiSelectCellComponentWithSearch data={[...l2Roles]} title={"L2 Roles"} />
                </div>
            </div>

            <div className={styles['label']}>Last updated on {getFormatedDate(updatedOn)} by {updatedBy}</div>

        </div>
    );
}

export default ConfigSummaryCard;